module.exports = __webpack_public_path__ + "img/Clubes-de-medida.521b790d.png";